import { render, staticRenderFns } from "./ClientActivity.vue?vue&type=template&id=4c7c3ef6"
import script from "./ClientActivity.vue?vue&type=script&lang=js"
export * from "./ClientActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports